// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__2Lya-","radioRow":"SimpleQuestionBuilderModal_radioRow__2t-nZ"};